const Builder = require('./BuilderBase');

module.exports = class PieChart extends Builder {
    constructor(title, properties) {
        super('graph_PieChart', title, properties);
    }
};
